"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";
import {
     loginAuthComplete,
     logoutAuthComplete,
     ajaxError,
     refreshTokenError,
     authUserProfileDetailsComplete,
     refreshTokenAuthComplete,
     preRegistrationComplete,
     preRegistrationActivateComplete,
     sendOtpComplete,
     sendOtpRequest,
     forgotPasswordEmailVeryficationComplete,
     forgotPasswordResetPasswordComplete,
     authGetUserDetailsComplete,
} from "../_actions";
import { authConstants, requestTypes, otpTypeConstants } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const loginAuthEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.AUTH_LOGIN_REQUEST),
          mergeMap((action) => {
               const { navigate, requetedUrl, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/auth/login",
                         {
                              email: payload.email,
                              password: payload.password,
                              validateOtp: payload.validateOtp,
                              otp: action.payload.otp,
                              browserFingerprint:
                                   action.payload.browserFingerprint,
                              rememberBrowser: action.payload.rememberBrowser,
                         },
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              if (ajaxResponse.response.data.otpRequired) {
                                   if (ajaxResponse.response.data.otpVerified) {
                                        navigate("/app/dashboard");

                                        return of(
                                             loginAuthComplete(
                                                  ajaxResponse.response,
                                             ),
                                        );
                                   } else {
                                        return of(
                                             sendOtpRequest({
                                                  userId: ajaxResponse.response
                                                       .data.userId,
                                                  timeStamp:
                                                       ajaxResponse.response
                                                            .data.timeStamp,
                                                  otpTypeId:
                                                       otpTypeConstants.AUTH_TYPE_LOGIN,
                                                  rememberBrowser: false,
                                                  browserFingerprint:
                                                       action.payload
                                                            .browserFingerprint,
                                                  navigate,
                                             }),

                                             // loginAuthComplete(
                                             //      ajaxResponse.response,
                                             // ),
                                        );
                                   }
                              } else {
                                   navigate("/app/dashboard");

                                   return of(
                                        loginAuthComplete(
                                             ajaxResponse.response,
                                        ),
                                   );
                              }
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const authUserProfileDetailsEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.AUTH_USER_PROFILE_DEATAILS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/auth/user-profile",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return authUserProfileDetailsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const logoutAuthEpic = (actions$) =>
     actions$.pipe(
          ofType(authConstants.AUTH_LOGOUT_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/auth/logout",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              action.payload.navigate("/");
                              return logoutAuthComplete(ajaxResponse.response);
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );

export const getNewActionTokenEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.AUTH_GET_REFRESH_TOKEN_REQUEST),
          mergeMap((action) =>
               ajax
                    .get(
                         "/api/auth/get-refreshtoken",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return refreshTokenAuthComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(refreshTokenError(error))),
                    ),
          ),
     );
};

export const reRegistrationEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.PRE_REGISTRATION_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/auth/pre-registration",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              preRegistrationComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const reRegistrationActivateEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.PRE_REGISTRATION_ACTIVATE_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/auth/pre-registration-activate",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              preRegistrationActivateComplete(
                                   ajaxResponse.response,
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const sendOptEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.SEND_OTP_REQUEST),
          mergeMap((action) => {
               const {
                    navigate,
                    otpTypeId,
                    timeStamp,
                    userId,
                    rememberBrowser,
                    browserFingerprint,
               } = action.payload;

               return ajax
                    .post(
                         "/api/auth/sendOtp",
                         {
                              timeStamp,
                              userId,
                              otpTypeId,
                              rememberBrowser,
                              browserFingerprint,
                         },
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         // map((ajaxResponse) => {
                         //      navigate(
                         //           "/auth/otp-verification/" +
                         //                otpTypeId +
                         //                "/" +
                         //                userId,
                         //      );

                         //      return sendOtpComplete(ajaxResponse.response);
                         // }),

                         concatMap((ajaxResponse) => {
                              navigate(
                                   "/auth/otp-verification/" +
                                        otpTypeId +
                                        "/" +
                                        userId,
                              );

                              if (
                                   otpTypeConstants.AUTH_TYPE_FOGOT_PASSWORD ==
                                   otpTypeId
                              ) {
                                   ajaxResponse.response.data = {
                                        showSuccess: false,
                                   };

                                   return of(
                                        sendOtpComplete(ajaxResponse.response),

                                        forgotPasswordResetPasswordComplete(
                                             ajaxResponse.response,
                                        ),
                                   );
                              }

                              if (
                                   otpTypeConstants.AUTH_TYPE_LOGIN == otpTypeId
                              ) {
                                   return of(
                                        sendOtpComplete(ajaxResponse.response),

                                        loginAuthComplete(
                                             ajaxResponse.response,
                                        ),
                                   );
                              }
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const reSendOptEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.RE_SEND_OTP_REQUEST),
          mergeMap((action) => {
               const {
                    otpTypeId,
                    userId,
                    rememberBrowser,
                    browserFingerprint,
                    phoneNumber,
               } = action.payload;

               const payload = {
                    userId,
                    otpTypeId,
                    rememberBrowser,
                    browserFingerprint,
               };

               if (otpTypeConstants.AUTH_TYPE_ADD_ACCOUNT == otpTypeId) {
                    payload.phoneNumber = phoneNumber;
               }

               return ajax
                    .post(
                         "/api/auth/reSendOtp",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return reSendOtpComplete(ajaxResponse.response);
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const forgotPasswordResetPasswordEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST),
          mergeMap((action) => {
               const { navigate, form, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/auth/forgotPasswordResetPassword",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              if (ajaxResponse.response.data.otpVerified) {
                                   navigate("/");

                                   return of(
                                        forgotPasswordResetPasswordComplete(
                                             ajaxResponse.response,
                                        ),
                                   );
                              } else {
                                   return of(
                                        sendOtpRequest({
                                             userId: payload.userId,
                                             rememberBrowser: false,
                                             browserFingerprint:
                                                  payload.browserFingerprint,

                                             timeStamp:
                                                  ajaxResponse.response.data
                                                       .timeStamp,
                                             otpTypeId:
                                                  otpTypeConstants.AUTH_TYPE_FOGOT_PASSWORD,
                                             navigate,
                                        }),

                                        // forgotPasswordResetPasswordComplete(
                                        //      ajaxResponse.response,
                                        // ),
                                   );
                              }
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const forgotPasswordEmailVeryficationEpic = (actions$) => {
     return actions$.pipe(
          ofType(authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST),
          mergeMap((action) => {
               const { form, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/auth/forgotPasswordEmailVerify",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              form.restart();
                              return forgotPasswordEmailVeryficationComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getUserDetailsEpic = (actions$) => {
     return actions$.pipe(
         ofType(authConstants.USER_DETAILS_REQUEST),
         mergeMap((action) => {
             return ajax
                 .post(
                     "/api/auth/get-user-details",
                     getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                 )
                 .pipe(
                     map((ajaxResponse) => {
                         return authGetUserDetailsComplete(ajaxResponse.response);
                     }),
                     catchError((error) => of(ajaxError(error))),
                 );
         }),
     );
 };
